export default __webpack_public_path__ + "static/media/48.d04eddea.svg";